import React, { useEffect, useState } from "react";
import axios from "axios";
import "./StaffAttendance.css"; // use your existing CSS

const BASE_URL = "/api";

// Helper to format dates
const formatDate = (d) => {
  if (!d) return "—";
  try {
    let parsed;
    if (Array.isArray(d)) {
      parsed = new Date(d[0], d[1] - 1, d[2], d[3], d[4], d[5]);
    } else if (typeof d === "string") {
      parsed = new Date(d.includes("T") ? d : d.replace(" ", "T"));
    } else if (d instanceof Date) {
      parsed = d;
    } else {
      return "—";
    }
    return isNaN(parsed.getTime()) ? "—" : parsed.toLocaleString();
  } catch (err) {
    return "—";
  }
};

const StaffAttendance = () => {
  const [societies, setSocieties] = useState([]);
  const [selectedSociety, setSelectedSociety] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [attendance, setAttendance] = useState([]);
  const [filteredAttendance, setFilteredAttendance] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const token = localStorage.getItem("token");

  // Fetch societies for dropdown
  useEffect(() => {
    const fetchSocieties = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/admin/names`, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined },
        });
        setSocieties(res.data);
      } catch (err) {
        console.error("Failed to fetch societies:", err);
      }
    };
    fetchSocieties();
  }, [token]);

  // Convert ISO date (YYYY-MM-DD) to DD/MM/YYYY
  const formatDateDDMMYYYY = (iso) => {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
  };

  // Fetch attendance
  const fetchAttendance = async () => {
    if (!selectedSociety || !startDate || !endDate) {
      setError("Please select society, start date, and end date.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await axios.get(`${BASE_URL}/admin/range`, {
        params: {
          societyName: selectedSociety,
          startDate: formatDateDDMMYYYY(startDate),
          endDate: formatDateDDMMYYYY(endDate),
        },
        headers: { Authorization: token ? `Bearer ${token}` : undefined },
      });

      setAttendance(res.data);
      setFilteredAttendance(res.data);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch attendance.");
    } finally {
      setLoading(false);
    }
  };

  // Search/filter by staff name or code
  useEffect(() => {
    const lower = searchQuery.toLowerCase();
    const filtered = attendance.filter(
      (a) =>
        a.staffName?.toLowerCase().includes(lower) ||
        a.staffCode?.toString().includes(lower)
    );
    setFilteredAttendance(filtered);
  }, [searchQuery, attendance]);

  return (
    <div className="reports-page">
      <h2>📋 Staff Attendance (Range-wise)</h2>

      {/* Filter Bar */}
      <div className="report-filter-bar">
        <h3>📅 Filter by Society & Date</h3>
        <div className="filter-controls">
          <div className="filter-item">
            <label>Society:</label>
            <select
              value={selectedSociety}
              onChange={(e) => setSelectedSociety(e.target.value)}
            >
              <option value="">Select Society</option>
              {societies.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
          </div>

          <div className="filter-item">
            <label>Start Date:</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="filter-item">
            <label>End Date:</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <button className="filter-btn" onClick={fetchAttendance}>
            Apply
          </button>
        </div>
      </div>

      {/* Search */}
      <div style={{ marginBottom: "10px" }}>
        <input
          type="text"
          placeholder="Search by staff name or code..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{ padding: "5px", width: "300px" }}
        />
      </div>

      {/* Table */}
      {loading ? (
        <p>Loading attendance...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : filteredAttendance.length > 0 ? (
        <table className="reports-table">
          <thead>
            <tr>
              <th>Staff Code</th>
              <th>Staff Name</th>
              <th>Check-In</th>
              <th>Check-Out</th>
            </tr>
          </thead>
          <tbody>
            {filteredAttendance.map((a) => (
              <tr
                key={a.id}
                className={!a.checkOutTime ? "missing-checkout" : ""}
              >
                <td>{a.staffCode}</td>
                <td>{a.staffName}</td>
                <td>{formatDate(a.checkInTime)}</td>
                <td>{formatDate(a.checkOutTime)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        !loading && <p>No attendance records found.</p>
      )}
    </div>
  );
};

export default StaffAttendance;
